




































import Vue from "vue"
import datasource, { ValidationFailureError } from "@/datasource"
import type { ValidationError } from "@/datasource"
import type { EmailTemplateInput } from "@/datasource/emails"

function initialData() {
  return {
    showDialog: false,
    saving: false,
    errors: {} as ValidationError,
    modified: {
      subject: "",
      content: "",
      type: "INVOICE",
    } as EmailTemplateInput,
  }
}

export default Vue.extend({
  data: initialData,

  watch: {
    showDialog(value) {
      if (!value) {
        this.close()
      }
    },
  },

  methods: {
    close() {
      Object.assign(this.$data, initialData())
    },

    async save() {
      this.saving = true
      let isOk = true

      try {
        {
          const result = await datasource.emails.createEmailTemplate(
            this.modified
          )

          if (result instanceof ValidationFailureError) {
            isOk = false
            this.errors = result.errors
          } else if (result instanceof Error) {
            throw result
          }
        }
      } catch (e) {
        console.error(e)
        isOk = false
      }

      if (isOk) {
        this.$emit("saved")
        this.close()
      }

      this.saving = false
    },
  },
})
